import { ACTION_GET_CONFIG, ACTION_GET_CONFIG_ERROR, ACTION_GET_CONFIG_SUCCESS } from "."
import * as api from "../../../api"

export const getConfigRequest = () => ({
    type: ACTION_GET_CONFIG,
    payload: {
    }
})

export const getConfigSuccess = data => ({
    type: ACTION_GET_CONFIG_SUCCESS,
    payload: {
        data
    }
})


export const getConfigError = (msg) => ({
    type: ACTION_GET_CONFIG_ERROR,
    payload: {
        msg
    }
})

export const getConfig = () => {
    return dispatch => {
        dispatch(getConfigRequest())
        api.getConfig()
            .then(({ data }) => {
                if (data.result.code !== 0) {
                    dispatch(getConfigError("error"));
                    return
                }

                delete data["result"]
                dispatch(getConfigSuccess(data));
            }).catch((err) => {

                console.log(err)

                dispatch(getConfigError("system error"))
            });
    }
}